// JS stuff
jQuery(document).ready(function($){

	console.log('19/09/22');

	var homeurl = "//corporateleisure.orokotravel.ie";
	//var homeurl = "/oroko-corp/wordpress";

	// fade in contact box
	/*
	$(window).scroll(function(){
		$(".consultation-button").css("opacity", 0 + $(window).scrollTop() / 1000);
		$(".callus-button").css("opacity", 0 + $(window).scrollTop() / 1000);
	});
	*/

	$('.lazy').lazyload({
			effect : "fadeIn"
	});  

	var s = skrollr.init({
		forceHeight: false,
		smoothScrolling: false
	});

	if (s.isMobile()) {
		s.destroy();
	}	
/*
	//Masonry
	var container = document.querySelector('#ms-container');
	var msnry = new Masonry( container, {
		singleMode: true,
		itemSelector: '.ms-item',
		columnWidth: '.ms-item',     
	});
	// end masonry
*/

	//Slick gallery
	$('.realslick').slick({
		arrows: false,
		centerMode: true,
		centerPadding: '0px',
		slidesToShow: 1,
		variableWidth: true,
		mobileFirst: true,
		responsive: [
		{
			breakpoint: 480,
			settings: {
				variableWidth: true,
			}
		}
		]		
	})
	.on('setPosition', function (event, slick) {
		slick.$slides.css('height', slick.$slideTrack.height() + 'px');
	});
	$('.slick-prev').click(function(){
		$(".realslick").slick('slickPrev');
	});
	$('.slick-next').click(function(){
		$(".realslick").slick('slickNext');
	});	

	//Slick-partners
	$('.slick-partners').slick({
		arrows: true,
		infinite: true,
		centerPadding: '20%',
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [
		  {
			breakpoint: 1024,
			settings: {
			  slidesToShow: 5,
			  slidesToScroll: 1,
			}
		  },
		  {
			breakpoint: 600,
			settings: {
			  slidesToShow: 3,
			  slidesToScroll: 1
			}
		  },
		  {
			breakpoint: 480,
			settings: {
			  slidesToShow: 2,
			  slidesToScroll: 1
			}
		  }
		]
	});

	// widgets gallery
	$(".wdgt-carousel").each(function(index){
		var dataid = $(this).attr("data-id");
		console.log(dataid);

		var $slider = $('.'+dataid+' .widgetslick');

		if ($slider.length) {
			var currentSlide;
			var slidesCount;
			var sliderCounter = document.querySelector('.'+dataid+' .slider__counter');
			
			var updateSliderCounter = function(slick, currentIndex) {
				currentSlide = slick.slickCurrentSlide() + 1;
				slidesCount = slick.slideCount;
				$(sliderCounter).html('<span>' + currentSlide + '</span>/' +slidesCount)
			};
	
			$slider.on('init', function(event, slick) {
				//$slider.append(sliderCounter);
				updateSliderCounter(slick);
			});
	
			$slider.on('afterChange', function(event, slick, currentSlide) {
				updateSliderCounter(slick, currentSlide);
			});
	
			$slider.slick({
				arrows: false,
				centerMode:true,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				cssEase: 'linear',
				variableWidth: true
			});
			$('.'+dataid+' .leftslick').click(function(){
				$('.'+dataid+' .widgetslick').slick('slickPrev');
			});
			$('.'+dataid+' .rightslick').click(function(){
				$('.'+dataid+' .widgetslick').slick('slickNext');
			});	
		}		
	});

	//Slick-content carousel widget
	$(".wdgt-car").each(function(index){
		var dataid = $(this).attr("data-id");
		console.log(dataid);

		var $sliderc = $('.'+dataid+' .slick-content');

		if ($sliderc.length) {
			var currentSlide;
			var slidesCount;
			var sliderCounter = document.querySelector('.'+dataid+' .slider__count');
			
			var updateSliderCounter = function(slick, currentIndex) {
				currentSlide = slick.slickCurrentSlide() + 1;
				slidesCount = slick.slideCount;
				$(sliderCounter).html('<span>' + currentSlide + '</span>/' +slidesCount)
			};

			$sliderc.on('init', function(event, slick) {
				//$sliderc.append(sliderCounter);
				updateSliderCounter(slick);
			});

			$sliderc.on('afterChange', function(event, slick, currentSlide) {
				updateSliderCounter(slick, currentSlide);
			});

			$sliderc.slick({
				arrows: false,
				slidesToShow: 1
			});
			$('.'+dataid+' .leftcslick').click(function(){
				$('.'+dataid+' .slick-content').slick('slickPrev');
			});
			$('.'+dataid+' .rightcslick').click(function(){
				$('.'+dataid+' .slick-content').slick('slickNext');
			});	
		}
	});
/* END SLICK SLIDER */

	$('.spincrement').spincrement({
		easing: 'linear'
	});


	if ($("#oroko").find(".subscribe-me").length > 0){ 
		// Newsletter Popup
		// https://github.com/peachananr/subscribe-better
		// https://github.com/js-cookie/js-cookie
		// Cookie set on newsletter form submit and modal close
		var subscriber = Cookies.get('subscriber');
		var nothanks   = Cookies.get('nothanks');

		if (subscriber != 'yes') {
			if (nothanks != 'yes') {
				$(".subscribe-me").subscribeBetter({
					trigger: "onidle", 
					animation: "fade",
					delay: 2000,
					showOnce: true,
					autoClose: false,
					scrollableModal: false
				});
			}
		}
	};
	/*
	if ($("#oroko").find(".bookcon").length > 0){ 
		$( ".bookcon" ).on( "click", function() {
			console.log('BOOK CON!');
			$.tinyModal({
				buttons: [],
				title: '',
				html: '#tinymodal'
			});
		});
	}
	*/

	$(document).on('closing', '#modal', function (e) {
		Cookies.set('nothanks', 'yes', { expires: 14 }); // set cookie for 1 day for HCP user
		//console.log('Cookie set nom nom');
	});

	$( ".menubutt" ).on( "click", function() {
		$( "#overlay" ).toggle();
		$(".menubutt").text(function(i, text){
			return text === "Close" ? "Menu" : "Close";
		})
	});

	$.fn.scrollView = function () {
		return this.each(function () {
			$('html, body').animate({
				scrollTop: $(this).offset().top
			}, 2000);
		});
	}  
	$('.scrollto').click(function (event) {
		event.preventDefault();
		$('.scrolltoloc').scrollView();
	});  

	// FITVIDS - Target your video container
	$('#fitvid').fitVids();   


// CONTACT FORM - side popup and contact page
const frm       = $('#consultationForm');
const radar	  = homeurl+'/wp-content/themes/oroko-corp/inc/radar.php';
const redirect  = homeurl+'/thank-you-for-contacting-us/';

$(frm).validate({
    // Specify validation rules
    rules: {
      // The key name on the left side is the name attribute
      // of an input field. Validation rules are defined
      // on the right side
      name: "required",
      email: {
        required: true,
        // Specify that email should be validated
        // by the built-in "email" rule
        email: true
      },
	  source: "required"
    },
    // Specify validation error messages
    messages: {
      name: "Please enter your name",
      email: "Please enter a valid email address"
    },
    // Make sure the form is submitted to the destination defined
    // in the "action" attribute of the form when valid
    submitHandler: function(form) {

		//console.log(frm.serialize());
		$.ajax({
			type: frm.attr('method'),
			url: radar,
			data: frm.serialize(),
			success: function (data) {
				console.log('Consultation success.');
				window.location.href = redirect;
			},
			error: function (data) {
				//console.log('Consultation request error - no signup.');
				//console.log(data);
				$('#consultationForm').hide();
				$('#formerror').delay( 2000 ).show();
			},
		});		
	}

});
// End old contact form

function atLeastOneCheckboxIsChecked(){
    const checkboxes = Array.from(document.querySelectorAll(".chk"));
    return checkboxes.reduce((acc, curr) => acc || curr.checked, false);
}

// Multi Brochure FORM
const frmM      = $('#brochureFormMulti');
const radarM	  = homeurl+'/wp-content/themes/oroko-corp/inc/radar4.php';
const redirectM  = homeurl+'/thank-you-brochure/';

// check which brochures to send
$(".brochuresdl .chk").change(function() {
    var checkbox = $(this);
	var chkname = $(this).attr("name");

    if (checkbox.is(':checked'))
    {
        console.log('checked');
		var chktitle = $("input:hidden[name='"+chkname+"_Title']").attr("data-val");
		var chkimg = $("input:hidden[name='"+chkname+"_ImageUrl']").attr("data-val");
		var chkurl = $("input:hidden[name='"+chkname+"_PdfUrl']").attr("data-val");

		$("input:hidden[name='"+chkname+"']").val('on');
		$("input:hidden[name='"+chkname+"_Title']").val(chktitle);
		$("input:hidden[name='"+chkname+"_ImageUrl']").val(chkimg);
		$("input:hidden[name='"+chkname+"_PdfUrl']").val(chkurl);	
    }else
    {
		$("input:hidden[name='"+chkname+"']").val('');
		$("input:hidden[name='"+chkname+"_Title']").val('');
		$("input:hidden[name='"+chkname+"_ImageUrl']").val('');
		$("input:hidden[name='"+chkname+"_PdfUrl']").val('');
        console.log('not checked');
    }
});
// submit form
frmM.submit(function (e) {

	e.preventDefault();

	if(atLeastOneCheckboxIsChecked()) {
		console.log(frmM.serialize());
		// true - bruchure selected so submit
		$.ajax({
			type: 'POST',
			url: radarM,
			data: frmM.serialize(),
			success: function (data) {
				//console.log('success');
				console.log(data);
				window.location.href = redirectM;
			},
			error: function (data) {
				//console.log('error');
				console.log(data);
				$('#brochureFormMulti').hide();
				$('#formerror').delay( 2000 ).show();
			},
		});	
			
	} else {
		console.log('form submit');
		alert("Please select a brochure");
	}

});
// End multi brochure form

// Brochure FORM
const frmb      = $('#brochureForm');
const radar3	  = homeurl+'/wp-content/themes/oroko-corp/inc/radar3.php';
const redirectB  = homeurl+'/thank-you-brochure/';

frmb.submit(function (e) {

	e.preventDefault();

	$.ajax({
		type: frmb.attr('method'),
		url: radar3,
		data: frmb.serialize(),
		success: function (data) {
			//console.log('Brochure request was successful.');
			//console.log(data);
			window.location.href = redirectB;
		},
		error: function (data) {
			//console.log('Brochure request error.');
			//console.log(data);
			$('#brochureForm').hide();
			$('#formerror').delay( 2000 ).show();
		},
	});

});
// End brochure form

// Newsletter FORM
	const frm2 		= $('#newsletterForm');
	const radar2 		= homeurl+'/wp-content/themes/oroko-corp/inc/radar2.php';
	const redirect2 	= homeurl+'/thank-you/';

	frm2.submit(function (e) {

		e.preventDefault();

		$.ajax({
			type: frm2.attr('method'),
			url: radar2,
			data: frm2.serialize(),
			success: function (data) {
				//$('#successForm').show();	
				console.log('Newsletter signup success footer');
				Cookies.set('subscriber', 'yes', { expires: 365 });
				//console.log('Sub nom nom nom');
				window.location.href = redirect2;
				$('#newsletterForm').hide();
								
			},
			error: function (data) {
				//console.log(data);
				//console.log('Newsletter signup error footer');
				$('#newsletterForm').hide();
				$('#newsletterformerror').show();
			},
		});

	});  
 
	// Newsletter FORM on Cookie Popup
	var frm3 		= $('#newsletterFormPop');
	var radarC 		= homeurl+'/wp-content/themes/oroko-corp/inc/radar2.php';
	var redirect3 	= homeurl+'/thank-you/';

	frm3.submit(function (e) {

		e.preventDefault();

		$.ajax({
			type: frm3.attr('method'),
			url: radarC,
			data: frm3.serialize(),
			success: function (data) {
				//console.log(data);
				//console.log('Newsletter signup success');
				Cookies.set('subscriber', 'yes', { expires: 365 });
				//console.log('Sub nom nom nom');
				$('#newsletterFormPop').hide();
				$('#formsuccess').delay( 2000 ).show();	
				$(".sb").closeWindow();		
				window.location.href = redirect3;
			},
			error: function (data) {
				//console.log(data);
				//console.log('Newsletter signup error');
				$('#newsletterFormPop').hide();
				$('#formerror').delay( 2000 ).show();			
			},
		});

	}); 	


// WIDGET FORM
const wdgtfrm   = $('#widgetForm');
const radar5	  = homeurl+'/wp-content/themes/oroko-corp/inc/radar5.php';
const thanks 	  = $('#thankyou').val();
const redirect5  = thanks;
//var redirect  = homeurl+'/thank-you-for-contacting-us/';

$(wdgtfrm).validate({
    // Specify validation rules
    rules: {
      // The key name on the left side is the name attribute
      // of an input field. Validation rules are defined
      // on the right side
      name: "required",
      email: {
        required: true,
        // Specify that email should be validated
        // by the built-in "email" rule
        email: true
      },
	  source: "required"
    },
    // Specify validation error messages
    messages: {
      name: "Please enter your name",
      email: "Please enter a valid email address"
    },
    // Make sure the form is submitted to the destination defined
    // in the "action" attribute of the form when valid
    submitHandler: function(form) {

		$.ajax({
			type: wdgtfrm.attr('method'),
			url: radar5,
			data: wdgtfrm.serialize(),
			success: function (data) {
				console.log('Success form');
				window.location.href = redirect5;
			},
			error: function (data) {
				//console.log('Consultation request error ');
				//console.log(data);
				$('#widgetForm').hide();
				$('#formerror').delay( 2000 ).show();
			},
		});
		
	}

});
// End widget form	

	//AJAX load more
	$('.load_more').on('click', 'a', function(e){
		e.preventDefault();
		var link = $(this).attr('href');

		$('.load_more').html('<span class="loader">Loading...</span>');
		$.get(link, function(data) {
			var post = $("#posts .post ", data);
			$('#posts').append(post);
		});
		$('.load_more').load(link+' .load_more a');
	});	

	// show hide div - add data="idname" of #id you want to show 
	$('.button-more').on('click', function () {
		var hdncon = $(this).attr('data');			
		//$('#'+hdncon).toggleClass('hide show');
		$('#'+hdncon).slideToggle();
		$(this).text(function(i, text){
			return text === "MORE" ? "CLOSE" : "MORE";
		})	

	});

	// DISABLE MOUSE SCROLL IN MAPS
	// enable the pointer events only on click;
	$('.gmap-wrapper').on('click', function () {
		$('.gmap-wrapper iframe').removeClass('scrolloff'); // set the pointer events true on click
	});
	// you want to disable pointer events when the mouse leave the canvas area;
	$(".gmap-wrapper").mouseleave(function () {
		$('.gmap-wrapper iframe').addClass('scrolloff'); // set the pointer events to none when mouse leaves the map area
	});  

	// RESIZE SELECT MENU
	$("#compute_option").html($('#to_be_resized option:selected').text()); 
	$("#to_be_resized").width($("#compute_select").width()); 

	$('#to_be_resized').change(function(){
		$("#compute_option").html($('#to_be_resized option:selected').text()); 
		$(this).width($("#compute_select").width());  
	});
	// second
	$("#compute_option2").html($('#to_be_resized2 option:selected').text()); 
	$("#to_be_resized2").width($("#compute_select2").width()); 

	$('#to_be_resized2').change(function(){
		$("#compute_option2").html($('#to_be_resized2 option:selected').text());
		$(this).width($("#compute_select2").width());  
	});

	//Hidden types
	$( ".select-holtype-init" ).on( "click", function() {
		$(".select-holtype").toggleClass("opacity");
	});	

	$('.style-check input').on('click', function () {
	  var checkedbox = '';
	  $('.style-check :checked').each(function() {
	    checkedbox += $(this).attr('id') + ' / ';
	  });
	  checkedbox = checkedbox.replace("any,", "");
	  $( ".rpl" ).text( checkedbox );
	  //console.log(checkedbox);
	});

	$('.style-check input.checkall').on('click', function () {
		var checkedbox = '';
		$( ".rpl" ).text( checkedbox + 'any' );
	});	

	$('input.checkall').on('change', function() {
		$('input.checksingle').not(this).prop('checked', false);  
	});	
	$('input.checksingle').on('change', function() {
		$('input.checkall').not(this).prop('checked', false);  
	});		

	$(".custom-select").each(function() {
		var classes = $(this).attr("class"),
			id      = $(this).attr("id"),
			name    = $(this).attr("name");
		var template =  '<div class="' + classes + '">';
			template += '<span class="custom-select-trigger">' + $(this).attr("placeholder") + '</span>';
			template += '<div class="custom-options">';
			$(this).find("option").each(function() {
			  template += '<span class="custom-option ' + $(this).attr("class") + '" data-value="' + $(this).attr("value") + '">' + $(this).html() + '</span>';
			});
		template += '</div></div>';
		
		$(this).wrap('<div class="custom-select-wrapper"></div>');
		$(this).hide();
		$(this).after(template);
	  });
	  
	  $(".custom-option:first-of-type").hover(function() {
		$(this).parents(".custom-options").addClass("option-hover");
	  }, function() {
		$(this).parents(".custom-options").removeClass("option-hover");
	  });
	  $(".custom-select-trigger").on("click", function() {
		$('html').one('click',function() {
		  $(".custom-select").removeClass("opened");
		});
		$(this).parents(".custom-select").toggleClass("opened");
		event.stopPropagation();
	  });
	$(".custom-option").on("click", function() {
		$(this).parents(".custom-select-wrapper").find("select").val($(this).data("value"));
		$(this).parents(".custom-options").find(".custom-option").removeClass("selection");
		$(this).addClass("selection");
		$(this).parents(".custom-select").removeClass("opened");
		$(this).parents(".custom-select").find(".custom-select-trigger").text($(this).text());
	});

	var sample1 = $("#slidereveal").slideReveal({
		trigger: $("#revealtrigg"),
		overlay: true,
		width: 500,
		shown: function(slider, trigger){
			$( "body" ).addClass( "modal-open" );
		},
		hidden: function(slider, trigger){
			$( "body" ).removeClass( "modal-open" );
		}		
	})

	/*
	var sample2 = $("#sliderevealb").slideReveal({
		trigger: $("#revealtriggb"),
		overlay: true,
		width: 500,
		shown: function(slider, trigger){
			$( "body" ).addClass( "modal-open" );
		},
		hidden: function(slider, trigger){
			$( "body" ).removeClass( "modal-open" );
		}
	})	
*/
	$(".toggler").click(function(){
		sample1.slideReveal("toggle");
	});

	// Contact us menu item opens side contact bar
	$("#mega-menu-item-2790 > a.mega-menu-link").on('click', function() {
		event.preventDefault();
		sample1.slideReveal("toggle");
	});

	// Request brochure menu item opens side contact bar
	/*$("#mega-menu-item-6809 > a.mega-menu-link").on('click', function() {
		event.preventDefault();
		sample2.slideReveal("toggle");
	});	*/

	$(".closebtn").on('click', function() {
		event.preventDefault();
		sample1.slideReveal("hide");
		//sample2.slideReveal("hide");
	});	

	// MODAL to play video
	$( ".play-video" ).on( "click", function() {
		var vidID = $(this).attr("data-index");
		$.tinyModal({
			buttons: [],
			title: '',
			html: '#tinymodal.video-'+vidID
		});
	});

	// MODAL - newsletters
	$( ".tinymodal-modal" ).on( "click", function(e) {
		e.preventDefault();
		var newsletterid = $(this).attr("data-index");
		$.tinyModal({
			buttons: [],
			title: '',
			html: '#tinymodal.newsl-'+newsletterid
		});
		//console.log(newsletterid);
	});


	/* TRIP FINDER */
	//Left menu filters
	$('.list-filters .filter-link').on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('activeFilter');
		$(".loadholidays").addClass("is-active");
		// check if already in selected items, clone over if not there
		if( $('.selected-filters a[data-id="'+$(this).data('id')+'"]').length ) {
			$('.selected-filters a[data-id="'+$(this).data('id')+'"]').remove();
		} else {
			$(this).clone().appendTo('.selected-filters');
		}
		editFilterInputs($('#filters-' + $(this).data('type')), $(this).data('id'));

		if ($(".filter-link.activeFilter")[0]){
			filterProducts();
		} else {
			//if there are no filters selected
			$('#result-count').html('<p>Please select some filters below to find your perfect experience.</p>');
			$('#main-product-list').html('');
			$(".loadholidays").removeClass("is-active");
		}
		
	});

	// Selected filters - pill buttons
	$(document).on('click', '.selected-filters .filter-link' , function(e) {
		e.preventDefault();
		$(".loadholidays").addClass("is-active");
		$('.list-filters a[data-id="'+$(this).data('id')+'"]').toggleClass('activeFilter');
		$(this).remove();

		editFilterInputs($('#filters-' + $(this).data('type')), $(this).data('id'));

		if ($(".filter-link.activeFilter")[0]){
			filterProducts();
		} else {
			//if there are no filters selected
			$('#result-count').html('<p>Please select some filters below to find your perfect experience.</p>');
			$('#main-product-list').html('');
			$(".loadholidays").removeClass("is-active");
		}
	});

	// clear selection
	$('.clearfilters').on('click', function(e) {
		e.preventDefault();
		$(".loadholidays").addClass("is-active");
		$('.filter-link').removeClass('activeFilter');
		$('.selected-filters .filter-link').remove();
		$('.filter--sidebar input').val('');
		$('#result-count').html('<p>Please select some filters below to find your perfect experience.</p>');
		$('#main-product-list').html('');
		//filterProducts();
	});	

	function editFilterInputs(inputField, value) {
		const currentFilters = inputField.val().split(',');
		const newFilter = value.toString();
		
		if (currentFilters.includes(newFilter)) {
			const i = currentFilters.indexOf(newFilter);
			currentFilters.splice(i, 1);
			inputField.val(currentFilters);
		} else {
			inputField.val(inputField.val() + ',' + newFilter);
		}
	}

	  function filterProducts() {
		const timeIds = $('#filters-time').val().split(',');
		const catIds = $('#filters-type').val().split(',');
		const regionIds = $('#filters-region').val().split(',');
		const countryIds = $('#filters-country').val().split(',');
		const priceIds = $('#filters-price').val().split(',');
		
		$.ajax({
		  type: 'POST',
		  url: homeurl+'/wp-admin/admin-ajax.php',
		  dataType: 'json',
		  data: {
			action: 'filter_products',
			timeIds,
			catIds,
			regionIds,
			countryIds,
			priceIds,
		  },
		  success: function(res) {
			$('#result-count').html('We have found '+res.total+' experiences for you');
			$('#main-product-list').html(res.html);
			$(".loadholidays").removeClass("is-active");
			console.log(res.total);
		  },
		  error: function(err) {
			$(".loadholidays").removeClass("is-active");
			console.error(err);
		  }
		})
	  }

	/* TRIP FINDER Category JUMP menu*/
	$('.list-filters .jump-link').on('click', function(e) {
		e.preventDefault();
		var holtype = $(this).data('curr');
		var holcountry = $(this).data('id');
		if (holcountry) {
			$(location).attr("href", homeurl+"/trip-finder/?catIds="+holtype+"&countryIds="+holcountry);
		} else {
			$(location).attr("href", homeurl+"/trip-finder/?catIds="+holtype);
		}
	});

	/* TRIP FINDER Mega form menu */
	$('.list-filters .form-link').on('click', function(e) {
		e.preventDefault();
		$('.list-filters .form-link').removeClass('activeFilter');
		//get details
		$(this).toggleClass('activeFilter');
		var holtype = $(this).data('type'); // category name
		var typeid = $(this).data('id'); // category id

		//types
		if (holtype == 'type') {
			if (typeid === '') {
				$('#filter-form #form-type').removeAttr('name', 'catIds');
				$('#filter-form #form-type').val('');
			} else {
				$('#filter-form #form-type').attr('name', 'catIds');
				$('#filter-form #form-type').val('');
				$('#filter-form #form-type').val(typeid);
			}
		}
		if (holtype == 'time') {
			if (typeid === '') {
				$('#filter-form #form-time').removeAttr('name', 'timeIds');
				$('#filter-form #form-time').val('');
			} else {
				$('#filter-form #form-time').attr('name', 'timeIds');
				$('#filter-form #form-time').val('');
				$('#filter-form #form-time').val(typeid);
			}
		}
		if (holtype == 'country') {
			if (typeid === '') {
				$('#filter-form #form-country').removeAttr('name', 'countryIds');
				$('#filter-form #form-country').val('');
			} else {
				$('#filter-form #form-country').attr('name', 'countryIds');
				$('#filter-form #form-country').val('');
				$('#filter-form #form-country').val(typeid);
			}
		}
		if (holtype == 'region') {
			if (typeid === '') {
				$('#filter-form #form-region').removeAttr('name', 'regionIds');
				$('#filter-form #form-region').val('');
			} else {
				$('#filter-form #form-region').attr('name', 'regionIds');
				$('#filter-form #form-region').val('');
				$('#filter-form #form-region').val(typeid);
			}
		}
		if (holtype == 'price') {
			if (typeid === '') {
				$('#filter-form #form-price').removeAttr('name', 'priceIds');
				$('#filter-form #form-price').val('');
			} else {
				$('#filter-form #form-price').attr('name', 'priceIds');
				$('#filter-form #form-price').val('');
				$('#filter-form #form-price').val(typeid);
			}
		}
	});

	/* TRIP FINDER Page form menu */
	$('.list-filters .pageform-link').on('click', function(e) {
		e.preventDefault();
		$('.list-filters .pageform-link').removeClass('activeFilter');
		//get details
		$(this).toggleClass('activeFilter');
		var holtype = $(this).data('type'); // category name
		var typeid = $(this).data('id'); // category id

		//types
		if (holtype == 'type') {
			if (typeid === '') {
				$('#pagefilter-form #form-type').removeAttr('name', 'catIds');
				$('#pagefilter-form #form-type').val('');
			} else {
				$('#pagefilter-form #form-type').attr('name', 'catIds');
				$('#pagefilter-form #form-type').val('');
				$('#pagefilter-form #form-type').val(typeid);
			}
		}
		if (holtype == 'time') {
			if (typeid === '') {
				$('#pagefilter-form #form-time').removeAttr('name', 'timeIds');
				$('#pagefilter-form #form-time').val('');
			} else {
				$('#pagefilter-form #form-time').attr('name', 'timeIds');
				$('#pagefilter-form #form-time').val('');
				$('#pagefilter-form #form-time').val(typeid);
			}
		}
		if (holtype == 'country') {
			if (typeid === '') {
				$('#pagefilter-form #form-country').removeAttr('name', 'countryIds');
				$('#pagefilter-form #form-country').val('');
			} else {
				$('#pagefilter-form #form-country').attr('name', 'countryIds');
				$('#pagefilter-form #form-country').val('');
				$('#pagefilter-form #form-country').val(typeid);
			}
		}
		if (holtype == 'region') {
			if (typeid === '') {
				$('#pagefilter-form #form-region').removeAttr('name', 'regionIds');
				$('#pagefilter-form #form-region').val('');
			} else {
				$('#pagefilter-form #form-region').attr('name', 'regionIds');
				$('#pagefilter-form #form-region').val('');
				$('#pagefilter-form #form-region').val(typeid);
			}
		}
		if (holtype == 'price') {
			if (typeid === '') {
				$('#pagefilter-form #form-price').removeAttr('name', 'priceIds');
				$('#pagefilter-form #form-price').val('');
			} else {
				$('#pagefilter-form #form-price').attr('name', 'priceIds');
				$('#pagefilter-form #form-price').val('');
				$('#pagefilter-form #form-price').val(typeid);
			}
		}
	});	
	
	// MODAL - tripfinder
	$( ".trip-modal" ).on( "click", function(e) {
		e.preventDefault();
		var findertype = $(this).attr("data-index");
		$.tinyModal({
			buttons: [],
			title: '',
			html: '#tinymodal.finder-'+findertype
		});
	});

	$('.readmore .collapsible').on('click', function () {
		$(this).text(function(i, text){
			return text === "MORE" ? "LESS" : "MORE";
		})	
	});

	$('.mobile-filter .collapsible').on('click', function () {
		$(this).text(function(i, text){
			return text === "View Filters" ? "Close Filters" : "View Filters";
		})	
	});	

// END document ready
});

// Trip Finder filter dropdowns
var coll = document.getElementsByClassName("collapsible");
var i;
for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}

var acoll = document.getElementsByClassName("active");
var ai;
for (ai = 0; ai < acoll.length; ai++) {
	var contentopen = acoll[ai].nextElementSibling;
	contentopen.style.maxHeight = contentopen.scrollHeight + "px";
	
}

/* TRIP FINDER Mega form menu */
var innerlinks = document.getElementsByClassName("form-link");
var il;
for (il = 0; il < innerlinks.length; il++) {
	innerlinks[il].addEventListener("click", function() {
		var contentf = this.closest(".col-content");
		var testContainer = document.querySelector('.filter-form');
		var buttonf = testContainer.querySelector('.active');
		var buttontitle = this.getAttribute('title');
		buttonf.innerHTML = buttontitle;
		buttonf.classList.toggle("active");
		
		if (contentf.style.maxHeight){
			contentf.style.maxHeight = null;
		} else {
			contentf.style.maxHeight = contentf.scrollHeight + "px";
		} 
	});
}
/* TRIP FINDER page form menu */
var innerlinks = document.getElementsByClassName("pageform-link");
var il;
for (il = 0; il < innerlinks.length; il++) {
	innerlinks[il].addEventListener("click", function() {
		var contentf = this.closest(".col-content");
		var testContainer = document.querySelector('.filter-pageform');
		var buttonf = testContainer.querySelector('.active');
		var buttontitle = this.getAttribute('title');
		buttonf.innerHTML = buttontitle;
		buttonf.classList.toggle("active");
		
		if (contentf.style.maxHeight){
			contentf.style.maxHeight = null;
		} else {
			contentf.style.maxHeight = contentf.scrollHeight + "px";
		} 
	});
}

//SELECT jump menu
function initJumpMenus() { 
	// Turns all <select> elements with the 'jumpmenu' class into jump menuss
	var selectElements = document.getElementsByTagName("select");
	var i = 0; 

	for( i = 0; i < selectElements.length; i++ ) {
		// Check for the class and make sure the element has an ID
		if( selectElements[i].className == "jumpmenu" && document.getElementById(selectElements[i].id) != "" ) {
			jumpmenu = document.getElementById(selectElements[i].id);
			jumpmenu.onchange = function() {
				if( this.options[this.selectedIndex].value != '' ) {
					// Redirect
					location.href=this.options[this.selectedIndex].value;
				}
			}
		} 
	}
}

window.onload = function() {
	initJumpMenus();
};

/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */
( function() {
	var isWebkit = navigator.userAgent.toLowerCase().indexOf( 'webkit' ) > -1,
	    isOpera  = navigator.userAgent.toLowerCase().indexOf( 'opera' )  > -1,
	    isIe     = navigator.userAgent.toLowerCase().indexOf( 'msie' )   > -1;

	if ( ( isWebkit || isOpera || isIe ) && document.getElementById && window.addEventListener ) {
		window.addEventListener( 'hashchange', function() {
			var id = location.hash.substring( 1 ),
				element;

			if ( ! ( /^[A-z0-9_-]+$/.test( id ) ) ) {
				return;
			}

			element = document.getElementById( id );

			if ( element ) {
				if ( ! ( /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) ) {
					element.tabIndex = -1;
				}

				element.focus();
			}
		}, false );
	}
})();
 
/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
( function() {
	var container, button, menu, links, subMenus, i, len;

	container = document.getElementById( 'site-navigation' );
	if ( ! container ) {
		return;
	}

	button = container.getElementsByTagName( 'button' )[0];
	if ( 'undefined' === typeof button ) {
		return;
	}

	menu = container.getElementsByTagName( 'ul' )[0];

	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof menu ) {
		button.style.display = 'none';
		return;
	}

	menu.setAttribute( 'aria-expanded', 'false' );
	if ( -1 === menu.className.indexOf( 'nav-menu' ) ) {
		menu.className += ' nav-menu';
	}

	button.onclick = function() {
		if ( -1 !== container.className.indexOf( 'toggled' ) ) {
			container.className = container.className.replace( ' toggled', '' );
			button.setAttribute( 'aria-expanded', 'false' );
			menu.setAttribute( 'aria-expanded', 'false' );
		} else {
			container.className += ' toggled';
			button.setAttribute( 'aria-expanded', 'true' );
			menu.setAttribute( 'aria-expanded', 'true' );
		}
	};

	// Get all the link elements within the menu.
	links    = menu.getElementsByTagName( 'a' );
	subMenus = menu.getElementsByTagName( 'ul' );

	// Set menu items with submenus to aria-haspopup="true".
	for ( i = 0, len = subMenus.length; i < len; i++ ) {
		subMenus[i].parentNode.setAttribute( 'aria-haspopup', 'true' );
	}

	// Each time a menu link is focused or blurred, toggle focus.
	for ( i = 0, len = links.length; i < len; i++ ) {
		links[i].addEventListener( 'focus', toggleFocus, true );
		links[i].addEventListener( 'blur', toggleFocus, true );
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		var self = this;

		// Move up through the ancestors of the current link until we hit .nav-menu.
		while ( -1 === self.className.indexOf( 'nav-menu' ) ) {

			// On li elements toggle the class .focus.
			if ( 'li' === self.tagName.toLowerCase() ) {
				if ( -1 !== self.className.indexOf( 'focus' ) ) {
					self.className = self.className.replace( ' focus', '' );
				} else {
					self.className += ' focus';
				}
			}

			self = self.parentElement;
		}
	}
} )();
